import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  Circle,
  Icon,
  Text,
  VStack,
} from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';

import * as fp from 'lodash/fp';

import { CartStatus } from '~/types/cart';
import { IoReceiptOutline } from 'react-icons/io5';
import { AiOutlineFrown } from 'react-icons/ai';

type UnableGroupNoticeModalProps = {
  isOpen: boolean;
  cartStatus: CartStatus;
};

export default function UnableGroupNoticeModal({
  isOpen,
  cartStatus,
}: UnableGroupNoticeModalProps) {
  const navigate = useNavigate();

  const displayData = fp.cond([
    [
      fp.eq(CartStatus.CANCELED),
      fp.always({
        title: '揪團已取消',
        description: (
          <Text textAlign="center" fontSize="sm">
            抱歉，團長取消了這次揪團
            <br />
            建議也可以自己點餐喔
          </Text>
        ),
        icon: AiOutlineFrown,
      }),
    ],
    [
      fp.eq(CartStatus.ORDERED),
      fp.always({
        title: '揪團已結束',
        description: (
          <Text textAlign="center" fontSize="sm">
            團長已送出這次的團購訂單
            <br />
            沒有即時加入到團購的夥伴下次請早喔
          </Text>
        ),
        icon: IoReceiptOutline,
      }),
    ],
    [
      fp.T,
      fp.always({
        title: '',
        description: <Text></Text>,
        icon: AiOutlineFrown,
      }),
    ],
  ])(cartStatus);

  return (
    <Modal size="sm" isCentered isOpen={isOpen} onClose={() => {}} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <VStack>
            <Circle size="12" bgColor="primaryLight">
              <Icon as={displayData.icon} boxSize="2rem" color="secondary" />
            </Circle>
            <Text fontWeight="bold">{displayData.title}</Text>
            {displayData.description}
          </VStack>
        </ModalBody>
        <ModalFooter p={0} borderTopWidth="1px">
          <Button variant="unstyled" isFullWidth fontWeight="normal" onClick={() => navigate('/')}>
            我知道了
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
